import React from "react";

/* eslint-disable max-len */
export default function ViewIcon({size}: {size?: number}) {
    return (
        <svg width={size || 10} height={size || 10} viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.544037 5.00001C1.49204 2.93447 3.5785 1.5 6 1.5C8.42149 1.5 10.5079 2.93447 11.456 4.99999C10.5079 7.06553 8.42149 8.5 5.99999 8.5C3.5785 8.5 1.49205 7.06553 0.544037 5.00001ZM7.99999 5C7.99999 6.10457 7.10456 7 5.99999 7C4.89542 7 3.99999 6.10457 3.99999 5C3.99999 3.89543 4.89542 3 5.99999 3C7.10456 3 7.99999 3.89543 7.99999 5ZM5.99999 6C6.55228 6 6.99999 5.55228 6.99999 5C6.99999 4.44772 6.55228 4 5.99999 4C5.44771 4 4.99999 4.44772 4.99999 5C4.99999 5.55228 5.44771 6 5.99999 6Z" fill="#63666A"/>
        </svg>
    );
}
